import React from 'react'
import PropTypes from 'prop-types'
import TitleBar from '../Layout/titleBar'
import { Row, Col } from 'react-flexbox-grid'
import Paper from '@material-ui/core/Paper';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state/index';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';

import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';



import DragAndDrop from '../Common/dragAndDrop'
import CropperModal from '../CropperModal'


const ItemPromocion = (props)=>{
    /**
     * nombre : titulo del item
     * descripcion: sub titulo, una linea
     * fecha: seguna linea de sub titulo, timestamp
     * monto: cantidad a la derecha, formateada como moneda
     * opciones: lista de opciones desplegables {nombre: string, handler: func}
     * onClick: click en cualquier lugar del item
     */
        return <div onClick={props.onClick} style={{padding:"5px", margin:"10px", cursor:(props.onClick)?"pointer":"default" }}>
            {(props.imagen !== undefined) && <img alt="" src={props.imagen} style={{backgroundColor:"#000", float:"left", width:"40px", height:"40px",marginRight:"16px", marginBottom:"32px", borderRadius:"100%" }} /> }
            <div style={{fontFamily:"Roboto",fontSize:"16px"}}>{props.nombre}</div>
            <div style={{fontFamily:"Roboto",fontSize:"14px", fontWeight:"300"}}>{props.descripcion}</div>

            {(props.opciones !== undefined) && <div onClick={(e)=>{e.stopPropagation()}} style={{float:"right", fontWeight:"normal", position:"relative", bottom:"22px",fontFamily:"Roboto",fontSize:"16px"}}>
            <PopupState variant="popover" popupId={"nuevo-usuario-menu"}>
          {popupState => (
            <React.Fragment>
                <IconButton style={{bottom:"15px"}}{...bindTrigger(popupState)}>
                    <MoreVertIcon />
                </IconButton>
              <Menu {...bindMenu(popupState)}>
                {
                    props.opciones.map((x)=>{return x!==undefined ? <MenuItem onClick={(...args)=>{x.handler(...args);popupState.close(...args)}}>{x.nombre}</MenuItem> : undefined})
                }
              </Menu>
            </React.Fragment>
          )}
        </PopupState>
            </div>}
        {(props.descripcion2 !== undefined) && <div style={{fontFamily:"Roboto",fontSize:"26px", fontWeight:"300", float:"right", position:"relative", top:"-26px"}}>{  props.descripcion2 + ' %'}</div>}
            
        </div>
    }

class PromoListado extends React.Component {

    render() {
        return (
            <div>

                {/* menú superior */}
                <TitleBar 
                    title='Promociones'
                    newButtonLink='/Promociones/Edit/0'
                    showSearch = {false}
                />
                

                <Paper style={{backgroundColor:"#FFFBFB"}}>
                <div >
                    <Row>
                        {this.props.promociones.map && this.props.promociones.map((x,i)=>
                        <Col md={6}>
                            <ItemPromocion {...this.props.mapToItem(x)}/>
                        </Col>)}
                    </Row>
                </div>
                </Paper>

                {/** confirmacion */}
                <Dialog 
                    disableBackdropClick={true}
                    fullWidth={true}
                    maxWidth={'sm'}
                    open={this.props.openModalConfirm}
                    onClose={this.props.handleOnCloseConfirmacion}>
                    <div style={{width:"100%", padding:"12px"}}>
                    <div style={{padding:"20px", textAlign:"center"}}>{this.props.mensajeConfirmacion}</div>
                    <div style={{textAlign:"left", marginTop:"44px", paddingLeft:"55%"}}>
                            <Button style={{marginRight:"12px"}} className="btnSecundario" onClick={this.props.handleOnCloseConfirmacion} >Cancelar</Button>
                            {
                                (this.props.botonOk.map)?
                                this.props.botonOk.map((x,i)=>
                                <Button variant="contained" className="btnPrincipal" onClick={()=>{this.props.handleOk[i](); this.props.handleOnCloseConfirmacion(); window.setTimeout(()=>{this.props.handleOnPagination(this.props.promociones.currentPage + 1 || 0);},700)}}>{this.props.botonOk[i]}</Button>
                                )
                                :<Button variant="contained" className="btnPrincipal" onClick={()=>{this.props.handleOk(); this.props.handleOnCloseConfirmacion(); window.setTimeout(()=>{this.props.handleOnPagination(this.props.promociones.currentPage + 1 || 0);},700)}}>{this.props.botonOk}</Button>
                            }
                        </div>
                    </div>
                </Dialog>


                        <DragAndDrop style={{position:"relative", top:"-13px"}}
                            accept='image/jpeg, image/png'
                            message='Arrastra la imágen para las promociones'
                            handleOnDrop={this.props.handleOnDropFile}
                            multiple={false}
                        />

            {(this.props.imagen)&&
            <div className='imageContainer'>
            
            <div>
            <img onClick={() => {this.props.handleOnOpenCropperModal()}}  src={this.props.imagen} style={{width:"250px", height:"313px"}} alt={""}></img>
            <div onClick={(e)=>{e.stopPropagation()}} style={{float:"right", fontWeight:"normal", position:"relative", bottom:"10px", left:"17px",fontFamily:"Roboto",fontSize:"16px"}}>
            <PopupState variant="popover" popupId={"nuevo-usuario-menu"}>
                {popupState => (
                    <React.Fragment>
                        <IconButton {...bindTrigger(popupState)}>
                            <MoreVertIcon />
                        </IconButton>
                        <Menu {...bindMenu(popupState)}>
                            <MenuItem onClick={this.props.handleEliminarImagen}>Borrar</MenuItem>
                        </Menu>
                    </React.Fragment>
                )}
            </PopupState>
            </div>
            </div>
            
            </div>
            }
                {this.props.openModalImagen &&
                    <CropperModal
                        ratio={4/5}
                        src={this.props.imagenOriginal}
                        handleOnCloseCropperModal={this.props.handleOnCloseCropperModal}
                        handleOnSaveImagenCortada={this.props.handleOnSaveImagenCortada}
                        open={this.props.openModalImagen}
                    />
                }
            </div>
        )
    }
}

PromoListado.propTypes = {
    promociones: PropTypes.object.isRequired,
    handleOnChangeFiltro: PropTypes.func,
    handleOnSave: PropTypes.func.isRequired,   
    handleOnSearch : PropTypes.func.isRequired,
    handleOnCloseConfirmacion: PropTypes.func,
}

PromoListado.defaultProps = {
    promociones: []
}

export default PromoListado